module.exports = __webpack_public_path__ + "static/img/SketchPngeb398ea022b1a486922628e702eaa8124f263fcc14e34f1aff10984cadd74c9a.a3d6f85d.png";